module.exports = __webpack_public_path__ + "static/media/cc.e53abbf8.svg";